import { formatDate, formatDateWithoutYear } from "utility/formatters";

export const SALE_CATEGORY_CASH = "Cash";
export const SALE_CATEGORY_BASIS = "Basis";
export const SALE_CATEGORY_HTA = "HTA";
export const SALE_CATEGORY_NO_PRICE = "No Price Established";
export const SALE_CATEGORIES = [SALE_CATEGORY_CASH, SALE_CATEGORY_BASIS, SALE_CATEGORY_HTA, SALE_CATEGORY_NO_PRICE];
export const POSITION_CATEGORIES = ["Buy", "Sell"];
export const SECURITY_TYPE_FUTURES = "Futures";
export const SECURITY_TYPE_OPTIONS = "Options";
export const SECURITY_TYPE_SPECIAL_OPTIONS = "Special Options";
export const SECURITY_TYPES = [SECURITY_TYPE_FUTURES, SECURITY_TYPE_OPTIONS, SECURITY_TYPE_SPECIAL_OPTIONS];
export const BUY_SELL_CODE_BUY = "1";
export const BUY_SELL_CODE_SELL = "2";
export const POSITION_SUMMARY_PATH = "/marketing/position_summary";
export const SALES_PATH = "/marketing/sales";

export const isFieldDisabled = (sale, field) => {
  const disabledConditions = {
    amount: !(
      sale?.category === SALE_CATEGORY_CASH ||
      sale?.category === SALE_CATEGORY_CASH ||
      sale?.category === SALE_CATEGORY_BASIS ||
      sale?.category === SALE_CATEGORY_HTA ||
      sale?.category === SALE_CATEGORY_NO_PRICE
    ),
    price: !(sale?.category === SALE_CATEGORY_CASH || sale?.category === SALE_CATEGORY_HTA),
    symbol: !(
      sale?.category === SALE_CATEGORY_CASH ||
      sale?.category === SALE_CATEGORY_BASIS ||
      sale?.category === SALE_CATEGORY_HTA
    ),
    basis: !(sale?.category === SALE_CATEGORY_CASH || sale?.category === SALE_CATEGORY_BASIS),
  };
  return disabledConditions[field];
};

export const formatDeliveryPeriod = (sale) => {
  if (sale?.delivery_period_start && sale?.delivery_period_end) {
    // Remove year from start date and end date
    const startDate = formatDateWithoutYear(sale.delivery_period_start);
    const endDate = formatDateWithoutYear(sale.delivery_period_end);
    return `${startDate} - ${endDate}`;
  }
  return "";
};

const DUPLICATE_OMIT = [
  "id",
  "CreateDate",
  "createDate",
  "LastUpdate",
  "lastUpdate",
  "trade_timestamp",
  "revenue",
  "market_value_timestamp",
  "original_id",
  "price_cash",
];

/** Copy a sale for create: same form fields, no identity / audit / computed. */
export function saleForDuplicate(sale) {
  if (!sale) return { is_active: true };
  const copy = { ...sale, is_active: true };
  if (copy.Notes && !copy.notes) copy.notes = copy.Notes;
  for (const key of DUPLICATE_OMIT) delete copy[key];
  return copy;
}
